export const AUDIT_LOG_RESOURCE = "v1/audit-log";
export const AUDIT_LOG_ROUTE = "audit-log";

export const AUDIT_LOG_PAGINATION_DEFAULTS = {
  initialCurrent: 1,
  initialPageSize: 10,
  hasPagination: true,
};

export const AUDIT_ACTION_VALUES = {
  login: "LOGIN",
  create: "CREATE",
  update: "UPDATE",
  patch: "PATCH",
  delete: "DELETE",
  cacheFlush: "CACHE_FLUSH",
  resetPassword: "RESET_PASSWORD", // NOSONAR - canonical audit action, not a credential
  changePassword: "CHANGE_PASSWORD", // NOSONAR - canonical audit action, not a credential
};

export const AUDIT_LOG_TEXTS = {
  title: "Auditoria",
  description:
    "Registro imutável das ações realizadas no painel administrativo. Cada evento guarda o ator, a ação, o recurso afetado, a requisição e o resultado — somente leitura.",
  filtersTitle: "Filtros",
  actorLabel: "Ator",
  actorPlaceholder: "Nome ou ID do usuário",
  resourceLabel: "Recurso",
  resourcePlaceholder: "Todos",
  actionLabel: "Ação",
  actionPlaceholder: "Todas",
  entityLabel: "Entidade (ID)",
  entityPlaceholder: "Ex.: pu_01, novo-fluxo",
  startDateLabel: "Data inicial",
  endDateLabel: "Data final",
  clearButton: "Limpar",
  searchButton: "Buscar",
  detailsTitle: "Detalhe do evento",
  closeButton: "Fechar",
  payloadLabel: "PAYLOAD",
  emptyText: "Nenhum evento de auditoria encontrado.",
  errorText: "Não foi possível carregar os eventos de auditoria.",
  invalidDateRange: "A data final deve ser maior ou igual à data inicial.",
};

export const AUDIT_ALL_RESOURCE_OPTION = { label: "Todos", value: "" };
export const AUDIT_ALL_ACTION_OPTION = { label: "Todas", value: "" };
